import OptionToggler from "../../../parts/OptionToggler";

const PullPreferences = ({
  isFe,
  isCoach,
  referAsClients,
  chatEnabled,
  userToSendInformation,
  roleName,
}) => {
  const referAsClientsOptions = [
    { label: "Athlete", value: false },
    { label: "Client", value: true },
  ];
  const chatEnabledOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];
  return (
    <>
      {!!(isFe || isCoach) && (
        <form id="form-pull" method="POST" data-noreset>
          <input
            type="hidden"
            name="userToSendInformation"
            defaultValue={userToSendInformation}
          />
          <input type="hidden" name="roleName" defaultValue={roleName}></input>
          <div className="row">
            <p className="mobile-hidden">User Reference</p>
            <div className="only-show-mobile">
              <p>User Reference</p>
            </div>
            <OptionToggler
              name="referAsClients"
              options={referAsClientsOptions}
              defaultValue={referAsClients}
            />
          </div>
          <div className="row" data-col="1/1">
            <p className="mobile-hidden">Chat Enabled</p>
            <div className="only-show-mobile">
              <p>Chat Enabled</p>
            </div>
            <OptionToggler
              name="chatEnabled"
              options={chatEnabledOptions}
              defaultValue={chatEnabled}
            />
          </div>
        </form>
      )}
    </>
  );
};
export default PullPreferences;
